import '../../../stylesheets/nav/nav.css';

const UserNameItem = ( { user } ) => {

    return (
        <div className="profile-menu-item">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" className="profile-menu-icon">
                <circle cx="12" cy="8" r="4" stroke="currentColor" strokeWidth="2"/>
                <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
            {user.name || 'User'}
        </div>
    )
}

export default UserNameItem